import React from 'react';
import { MAIL_MERGE_MAX_CONTACTS } from '../MailMerge/startContactMailMerge';

/**
 * The bar above the Agents or Vendors table once anything is ticked: how many
 * are selected, the offer to select every row the filter matches, and Clear.
 * The same bar the Properties list shows.
 *
 * The offer appears once the whole page is ticked and the filter matches
 * more. Past the mail merge's limit it says so instead, since selecting more
 * than a merge can take would only fail at the next step.
 */
export default function ContactSelectionBar({
    selectedCount, pageSelected, pageCount, totalCount, noun, plural,
    selectingAll, onSelectAll, onClear,
}) {
    if (!selectedCount) return null;

    const total = Number(totalCount) || 0;
    const wholePageTicked = pageCount > 0 && pageSelected === pageCount;
    const moreToSelect = wholePageTicked && total > selectedCount;

    let offer = null;
    if (moreToSelect && total <= MAIL_MERGE_MAX_CONTACTS) {
        offer = (
            <button type="button" className="ContactSelection_action" onClick={onSelectAll} disabled={selectingAll}>
                {selectingAll ? 'Selecting…' : `Select all ${total.toLocaleString()} ${plural} matching this filter`}
            </button>
        );
    } else if (moreToSelect) {
        offer = (
            <span className="ContactSelection_note">
                {`This filter matches ${total.toLocaleString()} ${plural}; a mail merge reaches up to `
                    + `${MAIL_MERGE_MAX_CONTACTS.toLocaleString()}. Narrow the filter to select them all.`}
            </span>
        );
    }

    return (
        <div className="ContactSelection">
            <span className="ContactSelection_count">
                {`${selectedCount.toLocaleString()} ${selectedCount === 1 ? noun : plural} selected`}
                {selectedCount > pageSelected ? ` (${pageSelected.toLocaleString()} on this page)` : ''}
            </span>
            {offer}
            <button type="button" className="ContactSelection_action" onClick={onClear}>
                Clear selection
            </button>
            <span className="ContactSelection_hint">Your selection is kept as you page through the list.</span>
        </div>
    );
}
